"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SERVER_ERROR = exports.NEWBUILDINGS_NOT_FOUND_ERROR = exports.FLATS_NOT_FOUND_ERROR = void 0;
const NEWBUILDINGS_NOT_FOUND_ERROR = exports.NEWBUILDINGS_NOT_FOUND_ERROR = {
  title: 'Ничего не найдено',
  text: 'Укажите другой ЖК или смените регион поиска'
};
const FLATS_NOT_FOUND_ERROR = exports.FLATS_NOT_FOUND_ERROR = {
  title: 'Ничего не найдено',
  text: 'Укажите другой адрес'
};
const SERVER_ERROR = exports.SERVER_ERROR = {
  title: 'Не удалось получить возможные варианты',
  text: 'Попробуйте еще раз'
};